// eslint-disable-next-line no-restricted-imports -- it's the only place we use react-helmet-async
import { Helmet } from "react-helmet-async";

import { PAGE_TITLE } from "./constant";

interface HelmetWrapperProps {
  title?: string;
  children?: React.ReactNode;
}

const HelmetWrapper: React.FC<HelmetWrapperProps> = ({ title, children }) => {
  return (
    <Helmet
      titleTemplate={`%s - ${PAGE_TITLE}`}
      defaultTitle={PAGE_TITLE}
    >
      {title && <title>{title}</title>}
      {children}
    </Helmet>
  );
};

export default HelmetWrapper;
